<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!-- 查询表单 -->
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column prop="Name" label="商品名称"></el-table-column>
      <el-table-column prop="ProductsCode" label="商品编码"></el-table-column>
      <el-table-column prop="Price" label="价格"></el-table-column>
      <el-table-column prop="ProductsType" label="商品分类"></el-table-column>
      <el-table-column prop="SendOutAdress" label="发货地"></el-table-column>
      <el-table-column
        prop="ExpressDeliveryPrice"
        label="快递费用"
      ></el-table-column>
      <el-table-column
        prop="InventoryQuantity"
        label="库存数量"
      ></el-table-column>
      <el-table-column prop="DeliveryTime" label="发货时间"></el-table-column>
      <!-- <el-table-column prop="Color" label="颜色分类"></el-table-column> -->
      <el-table-column prop="CoverPicture" label="封面图片" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.CoverPicture == ''">--</span>
          <el-image
            v-else
            style="width: 50px; height: 50px"
            :src="scope.row.CoverPicture"
            fit="cover"
            :preview-src-list="[scope.row.CoverPicture]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button type="danger" size="mini" @click="handleDel(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="isEdit ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      class="product-dialog"
      width="1200px"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="form"
        label-width="100px"
        label-position="left"
      >
        <div class="dialog-section">
          <h3 class="section-title">基本信息</h3>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="商品名称：" prop="Name">
                <el-input
                  v-model="formData.Name"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="商品分类：" prop="ProductsType">
                <el-select v-model="formData.ProductsType" style="width: 100%">
                  <el-option
                    v-for="item in ProjectTypes"
                    :key="item.Id"
                    :value="item.ItemText"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品编码：" prop="ProductsCode">
                <el-input v-model="formData.ProductsCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="价格：" prop="Price">
                <el-input-number
                  v-model="formData.Price"
                  :min="0"
                  :step="0.01"
                  controls-position="right"
                  class="full-width"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="对应比赛：" prop="MatchId">
                <el-select v-model="formData.MatchId" class="full-width">
                  <el-option
                    v-for="item in matchList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否热门：" prop="IsHot">
                <el-switch
                  v-model="formData.IsHot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-form-item>
              <el-form-item label="排序：" prop="OrderSort">
                <el-input-number
                  v-model="formData.OrderSort"
                  :min="0"
                  :step="1"
                  controls-position="right"
                  class="full-width"
                  placeholder="数字越小排序越靠前，相同则根据数据创建时间排序"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="dialog-section">
          <h3 class="section-title">物流信息</h3>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="发货地址：" prop="SendOutAdress">
                <el-input v-model="formData.SendOutAdress"></el-input>
              </el-form-item>
              <el-form-item label="快递费用：" prop="ExpressDeliveryPrice">
                <el-input-number
                  v-model="formData.ExpressDeliveryPrice"
                  :min="0"
                  :step="0.01"
                  controls-position="right"
                  class="full-width"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发货时间：" prop="DeliveryTime">
                <el-input
                  v-model="formData.DeliveryTime"
                  placeholder="如：48小时内发货"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="dialog-section">
          <h3 class="section-title">图片设置</h3>
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="封面图片：" prop="CoverPicture">
                <div class="upload-tip">建议尺寸：800x800px</div>
                <Upload
                  v-if="dialogVisible"
                  @upload="(url) => handleUpload('CoverPicture', url)"
                  @delete="() => handleDelete('CoverPicture')"
                  :fileUrl="formData.CoverPicture"
                ></Upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="详情图：" prop="DetailImage">
                <div class="upload-tip">建议宽度：1200px</div>
                <UploadArr
                  v-if="dialogVisible"
                  @upload="(urls) => handleUpload('DetailImage', urls)"
                  @delete="(urls) => handleUpload('DetailImage', urls)"
                  :fileUrlArr="formData.DetailImage"
                ></UploadArr>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="轮播图：" prop="CarouselImage">
                <div class="upload-tip">建议数量：3-5张</div>
                <UploadArr
                  v-if="dialogVisible"
                  @upload="(urls) => handleUpload('CarouselImage', urls)"
                  @delete="(urls) => handleUpload('CarouselImage', urls)"
                  :fileUrlArr="formData.CarouselImage"
                ></UploadArr>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="dialog-section">
          <h3 class="section-title"><i class="el-icon-goods"></i> 库存配置</h3>
          <div class="inventory-config">
            <div class="config-header">
              <el-button
                type="primary"
                size="small"
                @click="addInventoryRow"
                class="add-btn"
              >
                <i class="el-icon-plus"></i> 添加库存配置
              </el-button>
              <div
                class="config-summary"
                v-if="
                  formData.SpecificationsList &&
                  formData.SpecificationsList.length > 0
                "
              >
                <span class="summary-text">
                  已配置 {{ formData.SpecificationsList.length }} 个SKU
                </span>
                <span class="total-stock">总库存: {{ getTotalStock() }}</span>
              </div>
            </div>
            <div
              v-if="
                formData.SpecificationsList &&
                formData.SpecificationsList.length > 0
              "
              class="inventory-table-wrapper"
            >
              <el-table
                :data="formData.SpecificationsList"
                border
                stripe
                class="inventory-table"
                :header-cell-style="{
                  background: '#f5f7fa',
                  color: '#606266',
                  fontWeight: '600',
                }"
              >
                <el-table-column
                  label="序号"
                  type="index"
                  width="60"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="row-index">{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="尺码">
                  <template slot-scope="scope">
                    <div class="size-input-wrapper">
                      <i class="el-icon-price-tag size-icon"></i>
                      <el-input
                        v-model="scope.row.Size"
                        placeholder="如: S, M, L, XL"
                        size="small"
                        class="size-input"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="颜色">
                  <template slot-scope="scope">
                    <div class="color-input-wrapper">
                      <i class="el-icon-brush color-icon"></i>
                      <el-input
                        v-model="scope.row.Color"
                        placeholder="请输入颜色名称"
                        size="small"
                        class="color-input"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="缩略图" width="150" align="center">
                  <template slot-scope="scope">
                    <div class="thumbnail-upload-wrapper">
                      <div class="thumbnail-container">
                        <Upload
                          v-if="dialogVisible"
                          @upload="
                            (url) => handleThumbnailUpload(scope.$index, url)
                          "
                          @delete="() => handleThumbnailDelete(scope.$index)"
                          :fileUrl="scope.row.ThumbnailImage"
                          :fileType="'image'"
                          :showImage="true"
                          :showDelete="true"
                          :type="'product'"
                          class="thumbnail-upload"
                        ></Upload>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="库存数量" width="200">
                  <template slot-scope="scope">
                    <div class="stock-input-wrapper">
                      <i class="el-icon-box stock-icon"></i>
                      <el-input-number
                        v-model="scope.row.Count"
                        :min="0"
                        :step="1"
                        size="small"
                        controls-position="right"
                        class="stock-input"
                        placeholder="0"
                      ></el-input-number>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tooltip content="删除此配置" placement="top">
                      <el-button
                        type="danger"
                        size="mini"
                        @click="removeInventoryRow(scope.$index)"
                        icon="el-icon-delete"
                        circle
                        class="delete-btn"
                      ></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else class="empty-inventory">
              <div class="empty-icon">
                <i class="el-icon-box"></i>
              </div>
              <h4>暂无库存配置</h4>
              <p>请点击上方按钮添加商品的尺码、颜色和库存信息</p>
              <el-button
                type="primary"
                size="small"
                @click="addInventoryRow"
                plain
              >
                <i class="el-icon-plus"></i> 立即添加
              </el-button>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          :loading="isEdit ? editLoading : addLoading"
        >
          {{ isEdit ? "更新" : "创建" }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 联系人配置弹窗 -->
    <el-dialog
      title="配置订单发货联系人"
      :visible.sync="contactVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        :model="contactForm"
        :rules="contactRules"
        ref="contactForm"
        label-width="80px"
        label-position="left"
      >
        <el-form-item label="姓名：" prop="Name">
          <el-input
            v-model="contactForm.Name"
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话：" prop="Value">
          <el-input
            v-model="contactForm.Value"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="contactVisible = false">取消</el-button>
        <el-button type="primary" @click="handleContactConfirm">
          确定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Upload from "@/components/Upload.vue";
import UploadArr from "@/components/uploadImgArr.vue";
import { matchListAll } from "@/api/match/match";
import { GetSysDictByCode } from "@/api/SysDictionary/SysDictionary";
import {
  productList,
  addProduct,
  deleteProduct,
  productDetail,
  updateProduct,
  GetSelectOrderDeliverer,
  PostUpdateOrderDeliverer,
} from "@/api/product/product";
export default {
  components: { Toolbar, Upload, UploadArr },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addLoading: false, // 新增加载状态
      editLoading: false, // 编辑加载状态
      dialogVisible: false,
      isEdit: false,
      formData: {},
      formRules: {},
      matchList: [],
      currentColor: "", // 当前选择的颜色
      selectedColors: [], // 已选择的颜色数组
      ProjectTypes: [], // 商品类型列表
      contactVisible: false,
      // 联系人表单数据
      contactForm: {
        Name: "",
        Value: "",
      },
      // 联系人表单验证规则
      contactRules: {
        Name: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "姓名长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        Value: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getMatch();
    this.getDict();
  },
  methods: {
    handleDialogOpen(row) {
      if (row) {
        // 编辑模式
        productDetail({ Id: row.Id }).then((res) => {
          if (res.data.success) {
            this.formData = Object.assign({}, res.data.response);
            // 解析已有的颜色数据
            this.parseColorsFromString(this.formData.Color || "");
            // 初始化库存配置
            if (!this.formData.SpecificationsList) {
              this.formData.SpecificationsList = [];
            }
            this.isEdit = true;
            this.dialogVisible = true;
          }
        });
      } else {
        // 新增模式
        this.formData = {
          OrderSort: 0, // 排序默认值为0
          IsHot: false,
          Color: "",
          SpecificationsList: [], // 库存配置数组
        };
        this.selectedColors = [];
        this.currentColor = "";
        this.isEdit = false;
        this.dialogVisible = true;
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const submitMethod = this.isEdit ? updateProduct : addProduct;
          const loadingType = this.isEdit ? "editLoading" : "addLoading";

          this[loadingType] = true;
          this.formData.InventoryQuantity = this.getTotalStock();
          submitMethod(this.formData).then((res) => {
            this[loadingType] = false;
            if (res.data.success) {
              this.$message.success(res.data.msg);
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    handleEdit(row) {
      this.handleDialogOpen(row);
    },
    handleAdd() {
      this.handleDialogOpen();
    },
    handleUpload(type, url) {
      this.formData[type] = url;
    },
    handleDelete(type) {
      this.formData[type] = this.isEdit ? null : "";
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          return deleteProduct({
            Id: row.Id,
          });
        })
        .then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
    },
    getMatch() {
      matchListAll().then((res) => {
        this.matchList = res.data.response;
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        key: "",
      };
    },
    // 获取商品列表
    getList() {
      let params = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        ...this.filters,
      };
      productList(params).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
      });
    },
    callFunction(item) {
      this.filters = {
        key: item.search,
      };
      this[item.Func].apply(this, item);
    },
    // 添加颜色
    addColor(color) {
      if (color && !this.selectedColors.includes(color)) {
        this.selectedColors.push(color);
        this.updateColorString();
      }
      this.currentColor = "";
    },
    // 移除颜色
    removeColor(index) {
      this.selectedColors.splice(index, 1);
      this.updateColorString();
    },
    // 更新颜色字符串
    updateColorString() {
      this.formData.Color = this.selectedColors.join(",");
    },
    // 从字符串解析颜色
    parseColorsFromString(colorString) {
      if (colorString) {
        this.selectedColors = colorString
          .split(",")
          .filter((color) => color.trim());
      } else {
        this.selectedColors = [];
      }
    },
    // 添加库存配置行
    addInventoryRow() {
      if (!this.formData.SpecificationsList) {
        this.formData.SpecificationsList = [];
      }
      this.formData.SpecificationsList.push({
        Size: "",
        Color: "",
        Count: 0,
        ThumbnailImage: "",
      });
    },
    // 删除库存配置行
    removeInventoryRow(index) {
      this.formData.SpecificationsList.splice(index, 1);
    },
    // 处理缩略图上传
    handleThumbnailUpload(index, url) {
      if (
        this.formData.SpecificationsList &&
        this.formData.SpecificationsList[index]
      ) {
        this.formData.SpecificationsList[index].ThumbnailImage = url;
      }
    },
    // 处理缩略图删除
    handleThumbnailDelete(index) {
      if (
        this.formData.SpecificationsList &&
        this.formData.SpecificationsList[index]
      ) {
        this.formData.SpecificationsList[index].ThumbnailImage = "";
      }
    },
    // 计算总库存
    getTotalStock() {
      if (
        !this.formData.SpecificationsList ||
        this.formData.SpecificationsList.length === 0
      ) {
        return 0;
      }
      return this.formData.SpecificationsList.reduce((total, item) => {
        return total + (item.Count || 0);
      }, 0);
    },
    getDict() {
      GetSysDictByCode({
        code: "Project_Type",
      }).then((res) => {
        this.ProjectTypes = res.data.response;
      });
    },
    //  配置订单发货联系人
    async handleContact() {
      const res = await GetSelectOrderDeliverer();
      // 重置表单数据
      this.contactForm = res.data.response;
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.contactForm) {
          this.$refs.contactForm.clearValidate();
        }
      });
      this.contactVisible = true;
    },
    handleContactConfirm() {
      this.$refs.contactForm.validate(async (valid) => {
        if (valid) {
          // 表单验证通过，处理联系人信息
          const res = await PostUpdateOrderDeliverer(this.contactForm);
          if (res.data.success) {
            this.$message.success("联系人配置成功");
            this.contactVisible = false;
          } else {
            this.$message.error("联系人配置失败，请稍后重试");
          }
        } else {
          this.$message.error("请正确填写联系人信息");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 新增样式 */
.product-dialog {
  border-radius: 8px;
}

.dialog-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-title {
  margin: 0 0 20px 10px;
  font-size: 16px;
  color: #303133;
  font-weight: 600;
  border-left: 4px solid #409eff;
  padding-left: 10px;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-bottom: 8px;
}

.full-width {
  width: 100%;
}

::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

::v-deep .el-input__inner {
  border-radius: 4px;
}

/* 颜色选择器样式 */
.color-picker-container {
  width: 100%;
}

.selected-colors {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
  min-height: 32px;
  padding: 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
}

.color-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  background-color: #f4f4f5;
  border: 1px solid #e9e9eb;
  border-radius: 4px;
  font-size: 12px;
  color: #606266;
  transition: all 0.3s;
}

.color-tag:hover {
  background-color: #ecf5ff;
  border-color: #b3d8ff;
}

.color-preview {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
  margin-right: 6px;
}

.color-text {
  margin-right: 6px;
  font-family: monospace;
}

.color-tag .el-icon-close {
  cursor: pointer;
  font-size: 12px;
  color: #c0c4cc;
  transition: color 0.3s;
}

.color-tag .el-icon-close:hover {
  color: #f56c6c;
}

.selected-colors:empty::before {
  content: "请选择颜色";
  color: #c0c4cc;
  font-size: 14px;
}

/* 库存配置样式 */
.inventory-config {
  width: 100%;
}

.config-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 5px;
}

.config-summary {
  display: flex;
  gap: 15px;
  font-size: 14px;
}

.summary-text {
  color: #606266;
  font-weight: 500;
}

.total-stock {
  color: #409eff;
  font-weight: 600;
}

.inventory-table-wrapper {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 15px;
}

.inventory-table {
  width: 100%;
}

.inventory-table .el-table__row:hover {
  background-color: #f5f7fa !important;
}

.inventory-table .el-table__row {
  transition: background-color 0.3s;
}

.inventory-table .el-input__inner {
  border: 1px solid #e4e7ed;
  transition: border-color 0.3s;
}

.inventory-table .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.inventory-table .el-input-number {
  width: 100%;
}

.inventory-table .el-input-number .el-input__inner {
  text-align: center;
}

.row-index {
  font-weight: 600;
  color: #409eff;
}

.size-input-wrapper,
.stock-input-wrapper,
.color-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.size-icon,
.stock-icon,
.color-icon {
  display: block;
  color: #909399;
  font-size: 14px;
}

.size-input,
.stock-input,
.color-input {
  flex: 1;
}

.thumbnail-upload-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px 0;
}

.thumbnail-container {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 6px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumbnail-upload ::v-deep .avatar-uploader .el-upload {
  width: 60px;
  height: 60px;
  border: 2px dashed #dcdfe6;
  border-radius: 6px;
  background-color: #fafafa;
  transition: all 0.3s ease;
}

.thumbnail-upload ::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
  background-color: #f0f9ff;
}

.thumbnail-upload ::v-deep .avatar-uploader-icon {
  width: 60px;
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  color: #c0c4cc;
}

.thumbnail-upload ::v-deep .avatar {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  border: 2px solid transparent;
}

.thumbnail-upload ::v-deep .posR {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
}

.thumbnail-upload ::v-deep .deleteIcon {
  width: 16px;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  top: 2px;
  right: 2px;
}

.delete-btn {
  transition: all 0.3s;
}

.delete-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
}

.empty-icon {
  margin-bottom: 16px;
}

.empty-icon i {
  font-size: 48px;
  color: #c0c4cc;
}

.inventory-table {
  border-radius: 4px;
  overflow: hidden;
}

.empty-inventory {
  text-align: center;
  padding: 60px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  border: 2px dashed #dcdfe6;
  margin-top: 15px;
}

.empty-inventory h4 {
  margin: 16px 0 8px 0;
  color: #606266;
  font-size: 16px;
  font-weight: 600;
}

.empty-inventory p {
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #909399;
  line-height: 1.5;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 20px 10px;
  font-size: 16px;
  color: #303133;
  font-weight: 600;
  border-left: 4px solid #409eff;
  padding-left: 10px;
}

.section-title i {
  color: #409eff;
  font-size: 18px;
}

::v-deep .inventory-table .el-table__body-wrapper {
  max-height: 300px;
  overflow-y: auto;
}

::v-deep .inventory-table .el-input__inner {
  border: none;
  padding: 0 8px;
}

::v-deep .inventory-table .el-input-number {
  width: 100%;
}

::v-deep .inventory-table .el-input-number .el-input__inner {
  text-align: center;
}
</style>
